export default __webpack_public_path__ + "static/media/fake-artist-mobile.b4cafccc.svg";